export default [
  {
    title: 'Struggling With ADHD? Music Might Help You Focus.',
    url: 'https://www.vice.com/en/article/struggling-with-adhd-music-might-help-you-focus/',
    site: 'www.vice.com',
    img: 'https://www.vice.com/wp-content/uploads/sites/2/2025/01/struggling-with-adhd-music-might-help-you-focus.jpg',
  },
  {
    title: "Music can improve focus for people with ADHD—here's what to listen for",
    url: 'https://www.msn.com/en-us/health/other/music-can-improve-focus-for-people-with-adhd-here-s-what-to-listen-for/ar-AA1xfrw8',
    site: 'www.msn.com',
    img: 'https://img-s-msn-com.akamaized.net/tenant/amp/entityid/AA1xfrvI.img?w=768&h=405&m=6',
  },
  {
    title:
      'Brain.fm’s ADHD Music Breakthrough: Peer-Reviewed Study Validates World’s First Science-Backed, Purpose-Built Focus Music',
    url: 'https://cdn.brain.fm/pdfs/Press%20Release%20-%20Brain.fm%20Peer%20Reviewed%20Study.pdf',
    site: 'www.brain.fm',
    img: 'https://cdn.brain.fm/images/press/nat_comm_bio_cover.webp',
  },
  {
    title: 'How to Make the Perfect Playlist to Boost Brain Power, According to Neuroscience',
    url: 'https://www.inc.com/wanda-thibodeaux/how-to-make-perfect-playlist-to-boost-brain-power-according-to-neuroscience.html',
    site: 'www.inc.com',
    img: 'https://cdn.brain.fm/images/press/1.webp',
  },
  {
    title: '6 Ways Employers Can Spot, Manage, and Reduce Workplace Stress',
    url: 'https://www.americanexpress.com/en-us/business/trends-and-insights/articles/6-ways-employers-can-spot-manage-and-reduce-workplace-stress',
    site: 'www.americanexpress.com',
    img: 'https://cdn.brain.fm/images/press/2.webp',
  },
  {
    title:
      'What you need to know about the 5 types of brainwaves—for better sleep, health, and focus',
    url: 'https://www.wellandgood.com/good-advice/brainwaves-biohack-sleep-health-focus/',
    site: 'www.wellandgood.com',
    img: 'https://cdn.brain.fm/images/press/3.webp',
  },
  {
    title: '10 Ways To Use AI To Make Everyday Tasks A Little Easier',
    url: 'https://www.fastcompany.com/40547840/10-ways-to-use-ai-to-make-everyday-tasks-a-little-easier',
    site: 'www.fastcompany.com',
    img: 'https://cdn.brain.fm/images/press/4.webp',
  },
  {
    title: "Brain.fm's attention-boosting app gets $225K National Science grant",
    url: 'https://www.cnet.com/news/brain-fms-attention-boosting-app-gets-225k-national-science-grant/',
    site: 'www.cnet.com',
    img: 'https://cdn.brain.fm/images/press/5.webp',
  },
  {
    title: '3 Strategies to Painlessly Free up Time and Get More Done',
    url: 'https://www.entrepreneur.com/article/309278',
    site: 'www.entrepreneur.com',
    img: 'https://cdn.brain.fm/images/press/6.webp',
  },
  {
    title: 'How To Organize Your Life, Based On Your Myers-Briggs Type ',
    url: 'https://www.bustle.com/p/how-to-organize-your-life-based-on-your-myers-briggs-type-8525230',
    site: 'www.bustle.com',
    img: 'https://cdn.brain.fm/images/press/7.webp',
  },
  {
    title: '27 Founders Reveal Their Favorite Tool to Keep Them Organized',
    url: 'https://www.entrepreneur.com/slideshow/293729#1',
    site: 'www.entrepreneur.com',
    img: 'https://cdn.brain.fm/images/press/8.webp',
  },
  {
    title: '11 ways to eliminate distractions while working from home',
    url: 'https://www.techrepublic.com/article/11-ways-to-eliminate-distractions-while-working-from-home/',
    site: 'www.techrepublic.com',
    img: 'https://cdn.brain.fm/images/press/9.webp',
  },
  {
    title: "11 apps that have actually changed people's lives",
    url: 'https://www.businessinsider.com.au/apps-that-changed-peoples-lives-2016-7#/#headspace-1',
    site: 'www.businessinsider.com',
  },
  {
    title: 'Brain.fm Gives You Streaming Music to Focus, Relax, or Sleep To',
    url: 'http://lifehacker.com/brain-fm-gives-you-streaming-music-to-focus-relax-or-1782183834',
    site: 'www.lifehacker.com',
  },
  {
    title: 'Brain.fm for iOS',
    url: 'https://www.producthunt.com/posts/brain-fm-for-ios',
    site: 'www.producthunt.com',
  },
  {
    title: 'Can Listening to AI-Composed Music Boost Your Brain Function?',
    url: 'http://observer.com/2016/06/brain-fm-artificial-intelligence-music/',
    site: 'www.observer.com',
  },
  {
    title: 'Need to Focus? This Startup Promises It Has the Perfect Music for You',
    url: 'http://www.inc.com/kevin-j-ryan/brain-fm-artificial-intelligence-music-will-make-your-brain-focus.html',
    site: 'www.inc.com',
  },
  {
    title: 'Brain.FM: This Productivity Software Alters Your Brainwaves to Increase Focus',
    url: 'http://thehustle.co/brainfm-productivity-software-alters-brainwaves-to-increase-focus',
    site: 'www.thehustle.co',
  },
  {
    title: "According to Science, This Music's Designed to Help You Focus Now",
    url: 'https://www.themuse.com/advice/according-to-science-this-musics-designed-to-help-you-focus-now',
    site: 'www.themuse.com',
  },
  {
    title: 'Can this brainwave-stimulating music cure me of distraction?',
    url: 'http://www.dailydot.com/irl/brain-fm-music/',
    site: 'www.dailydot.com',
  },
  {
    title: 'Brain.fm brings musical AI to Rio Olympics’ training',
    url: 'http://readwrite.com/2016/08/07/halo-brings-training-finesse-olympic-athletes-hl1/',
    site: 'www.readwrite.com',
  },
  {
    title: 'This is Your Brain on Brain FM',
    url: 'http://writerunboxed.com/2016/01/07/this-is-your-brain-on-brain-fm/',
    site: 'www.writerunboxed.com',
  },
  {
    title: 'There’s An AI That’s Making Music to Improve Your Brain Function',
    url: 'https://futurism.com/theres-an-ai-thats-making-music-to-improve-your-brain-function/',
    site: 'www.futurism.com',
  },
  {
    title: 'Brain.fm uses AI-generated music to help you focus or relax on demand',
    url: 'http://www.digitaltrends.com/web/brainfm-ai-generated-music-for-focus-relaxation/',
    site: 'www.digitaltrends.com',
  },
  {
    title:
      'Brain.fm App Uses "Brain Stimulating" Music To Improve Concentration, But How Does It Work?',
    url: 'https://www.bustle.com/articles/169395-brainfm-app-uses-brain-stimulating-music-to-improve-concentration-but-how-does-it-work',
    site: 'www.bustle.com',
  },
  {
    title: 'Can Music Be Designed to Enhance Your Brain’s Performance?',
    url: 'https://collegeinfogeek.com/brain-enhancing-music/',
    site: 'www.collegeinfogeek.com',
  },
  {
    title: 'Brain.fm- Focus, Relax & Sleep Better with Music for the brain',
    url: 'http://www.stitcher.com/podcast/doug-egge/mind-pump/e/401-brainfm-focus-relax-sleep-better-with-music-for-the-48237295',
    site: 'www.stitcher.com',
  },
  {
    title: "Why US Greco Roman Wrestling Turned to an 'Audio Brain Stimulation' App",
    url: 'http://motherboard.vice.com/read/us-greco-roman-wrestling-brain-fm-app',
    site: 'motherboard.vice.com',
  },
  {
    title: 'Can music enhance brain waves and improve Olympic wrestlers’ performance?',
    url: 'https://www.statnews.com/2016/08/09/olympic-wrestlers-brain-music/',
    site: 'www.statnews.com',
  },
  {
    title: 'Episode 107',
    url: 'http://smartdrugsmarts.com/episode-107-brainwave-entrainment/',
    site: 'www.smartdrugsmarts.com',
  },
  {
    title: 'OLYMPIC WRESTLERS TUNE IN TO ARTIFICIAL INTELLIGENCE ‘SONGBOTS’',
    url: 'http://www.newsweek.com/artificial-intelligence-music-olympics-wrestling-488308',
    site: 'www.newsweek.com',
  },
  {
    title: 'Brain.fm Uses An Artificial Intelligence to Improve Your Brain Function',
    url: 'http://trendintech.com/2016/06/26/brain-fm-uses-an-artificial-intelligence-to-improve-your-brain-function/',
    site: 'www.trendintech.com',
  },
  {
    title: 'Here’s How You Can Focus When You Just Keep Getting Distracted At Work',
    url: 'http://elitedaily.com/life/focus-keep-getting-distracted-work/1541289/',
    site: 'www.elitedaily.com',
  },
  {
    title: 'How to train like an Olympian – eat loads of peanut butter and listen to robots',
    url: 'https://www.theguardian.com/sport/2016/aug/17/train-like-olympian-eat-peanut-butter-listen-robots',
    site: 'www.theguardian.com',
  },
];
